import React from 'react';
import { Box, Button, theme } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { AddIcon } from '@chakra-ui/icons';

interface props {
  title: string;
  loading: boolean;
  handleCancelButton: any;
  handleClick: any;
}

function FooterButtons(props: props) {
  return (
    <>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: '32px',
          columnGap: { sm: '16px', md: 0 },
        }}
      >
        <Button
          fontSize="sm"
          variant="brand"
          fontWeight="400"
          w={{ sm: '100%', md: 'auto' }}
          padding={'6px 16px'}
          h="40px"
          _focus={{
            borderColor: '#EEEFFC',
          }}
          tabIndex={0}
          onClick={props?.handleClick}
          isLoading={props?.loading}
          isDisabled={props?.loading}
        >
          {props?.title}
        </Button>
        <Button
          fontSize="sm"
          variant="outline"
          fontWeight="400"
          w={{ sm: '100%', md: 'auto' }}
          padding={'6px 16px'}
          color={'#D2D3E0'}
          borderColor={'#313248'}
          _focus={{
            borderColor: '#EEEFFC',
          }}
          tabIndex={0}
          _active={{
            backgroundColor: '#1F2025',
          }}
          _hover={{
            backgroundColor: '#1F2025',
          }}
          backgroundColor={'#1F2025'}
          h="40px"
          onClick={props?.handleCancelButton}
          isLoading={undefined}
          isDisabled={undefined}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
}

export default FooterButtons;
